import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = 'KES') {
  return new Intl.NumberFormat('en-KE', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
}

export function formatNumber(num) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(2) + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(0) + 'K';
  }
  return num.toString();
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-KE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

export function getInitials(name) {
  if (!name) return '??';
  return name
    .split(' ')
    .map(part => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function getStatusColor(status) {
  const statusColors = {
    active: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
    inactive: 'bg-rose-50 text-rose-700 ring-rose-600/20',
    pending: 'bg-amber-50 text-amber-700 ring-amber-600/20',
    paid: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
    scheduled: 'bg-blue-50 text-blue-700 ring-blue-600/20',
    completed: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
    present: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
    absent: 'bg-rose-50 text-rose-700 ring-rose-600/20',
    late: 'bg-amber-50 text-amber-700 ring-amber-600/20',
  };
  return statusColors[status?.toLowerCase()] || 'bg-slate-50 text-slate-600 ring-slate-500/10';
}
